//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import constant from '~/const';

export default {
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      filters: {
        searchString: '',
        referralProgramStartFrom: '',
        referralProgramStartTo: '',
        createdAtToDate: '',
        createdAtFromDate: '',
        traderUsername: '',
        levelList: [],
        cumulativeCurrencyId: 0,
      },
    };
  },

  computed: {
    ...mapState('userReferralReferrals', ['filterLists']),
    ...mapGetters('currencies', ['getCurrencyByTitle']),

    currencyList() {
      const { PRICE_EQUIVALENT_CURRENCY_LIST } = constant.currencies;
      const list = PRICE_EQUIVALENT_CURRENCY_LIST.map((e) => this.getCurrencyByTitle(e));
      return list;
    },

    dateToNaming() {
      if (this.$utils.getAppType() === 'p2pay') return 'createdAtToDate';
      return 'referralProgramStartTo';
    },

    dateFromNaming() {
      if (this.$utils.getAppType() === 'p2pay') return 'createdAtFromDate';
      return 'referralProgramStartFrom';
    },

    searchStringNaming() {
      if (this.$utils.getAppType() === 'p2pay') return 'traderUsername';
      return 'searchString';
    },
  },

  watch: {
    filters: {
      async handler(data) {
        const protocol = this.$utils.getAppType() === 'p2pay' ? this.setNew : this.setOld;
        await protocol(data);
        this.$emit('update');
      },
      deep: true,
    },
  },

  created() {
    const currency = this.getCurrencyByTitle(constant.currencies.PRICE_EQUIVALENT_CURRENCY_LIST[0]);
    this.filters.cumulativeCurrencyId = currency?.id || 0;
  },

  methods: {
    ...mapActions('userReferralReferrals', {
      setOld: 'setFilters',
    }),
    ...mapActions('referrals', {
      setNew: 'setFilters',
    }),
  },
};
